import React, { useEffect, useState } from "react";
import CustomTable from "../../components/CustomTable";
import moment from "moment";
import DatePicker from "../../components/FormFields/DatePicker";
import useApi from "../../hooks/useApi";
import { apiUrls } from "../../utils/api/apiUrls";
import InputWithIcon from "../FormFields/InputWithIcon";
import { icons } from "../../assets/icons";
import useDebounce from "../../hooks/useDebounce";
import SelectInput from "../FormFields/SelectInput";
import { approvedRequestsColumns } from "../Columns/Requests/ApprovedRequests";
import { useAuth } from "../../contexts/AuthContext";
import CustomButton from "../CustomButton";
import { downloadReports, getArrayOfSelectedStoresCode } from "../../utils/helpers";
import {
  useNavigate,
  createSearchParams,
  useSearchParams,
} from "react-router-dom";

const ApprovedRequests = () => {
  const { data = [], apiCall } = useApi();
  const {
    selectedStores = {},
    storeDropdownState = [],
    setSelectedStores,
    user: { userLabel = "" },
  } = useAuth();

  const {storeCode = ""} = selectedStores?.storeDetails || selectedStores?.[0] || {}

  const [searchText, setSearchText] = useState("");
  const debouncedSearchText = useDebounce(searchText, 500);
  const [checkboxPropData, setCheckboxPropData] = useState([]);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [startDate, setStartDate] = useState(
    moment(
      searchParams.get("startDate") || moment().subtract({ days: 7 }).toDate()
    ).toDate()
  );
  const [endDate, setEndDate] = useState(
    moment(searchParams.get("endDate") || new Date()).toDate()
  );

  // useEffect(() => {
  //   approvedRequestTableDataHandler(
  //     startDate,
  //     endDate,
  //     selectedStores?.storeDetails?.storeCode || ""
  //   );
  // }, []);

  const isStoreActive = userLabel == "Store";
  useEffect(() => {
    // if (isStoreActive) {
      approvedRequestTableDataHandler(
        startDate,
        endDate,
        selectedStores?.storeDetails?.storeCode || ""
      );
    // } else {
    //   if (storeCode.length > 0 && storeCode.length !== 0) {
    //     approvedRequestTableDataHandler(
    //       startDate,
    //       endDate,
    //       selectedStores?.storeDetails?.storeCode || ""
    //     );
    //   }
    // }
  }, [selectedStores]);

  const approvedRequestTableDataHandler = (start, end, storeC) => {
    navigate(
      {
        pathname: window.location.pathname,
        search: createSearchParams({
          startDate: start,
          endDate: end,
        }).toString(),
      },
      { replace: true }
    );
    // if(storeCode.length > 0){
      apiCall({
        url: apiUrls.dmsService.getRecords,
        dataToSend: {
          startDate: moment(start).startOf("d").format("YYYY-MM-DD HH:mm:ss"),
          metadataSchemaId: 13,
          endDate: moment(end || start)
            .endOf("d")
            .format("YYYY-MM-DD HH:mm:ss"),
          searchText: debouncedSearchText,
          status: "APPROVED",
          storeCodes: getArrayOfSelectedStoresCode(selectedStores, storeDropdownState) 
          // storeC
          //   ? storeC !== "All" ? [storeC] : null
          //   : userLabel == "Store" ? null : [storeCode],
        },
        method: "post",
        processData: true,
        accessor: "documents",
      });
    // }
  };

  const onChangeDate = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
    if (end !== null)
      approvedRequestTableDataHandler(
        start,
        end,
        selectedStores?.storeDetails?.storeCode || ""
      );
  };

  let reportData = [
    {
      sheet: "Reports",
      columns: [
        { label: "Date", value: (row) => row.date }, // Top level data
        { label: "Request For", value: (row) => row.head }, // Top level data
        // { label: "Sub Head", value: (row) => row.sub_head }, // Top level data
        { label: "Description", value: (row) => row.description }, // Top level data
        { label: "Rate", value: (row) => row.rate }, // Top level data
        { label: "Quantity", value: (row) => row.quantity }, // Top level data
        { label: "Total Amount", value: (row) => row.amount }, // Top level data
        { label: "Approval Status", value: (row) => row.approval_status }, // Top level data
      ],
      content: data,
    },
  ];

  let reportSettings = {
    fileName: "approvedRequestReport", // Name of the resulting spreadsheet
    extraLength: 3, // A bigger number means that columns will be wider
    writeMode: "writeFile", // The available parameters are 'WriteFile' and 'write'. This setting is optional. Useful in such cases https://docs.sheetjs.com/docs/solutions/output#example-remote-file
    writeOptions: {}, // Style options from https://docs.sheetjs.com/docs/api/write-options
    RTL: false, // Display the columns from right-to-left (the default value is false)
  };

  const downloadRequestReports = () => {
    downloadReports(reportData, reportSettings);
  };

  const setCheckData = (val) => {
    setCheckboxPropData(val);
  };

  return (
    <div className="flex flex-col gap-y-5">
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center gap-x-8">
          {/* {storeDropdownState?.length ? (
            <SelectInput
              options={[
                { name: "All", storeCode: "" },
                ...storeDropdownState?.map((item) => ({
                  name: `${item?.name} (${item?.storeCode})`,
                  storeCode: item?.storeCode,
                })),
              ]}
              onChange={(val) => {
                approvedRequestTableDataHandler(
                  startDate,
                  endDate,
                  val[0]?.storeCode || ""
                );
                setSelectedStores({ storeDetails: val?.[0] || {} });
              }}
              labelField="name"
              valueField="storeCode"
              selectClassName="!max-w-[18rem] !h-[4rem] !mt-0"
              onChangeFullRes={true}
              value={
                selectedStores?.storeDetails?.storeCode
                  ? selectedStores?.storeDetails?.storeCode
                  : null
              }
            />
          ) : null} */}
          {/* 
          <InputWithIcon
            placeholder="Search"
            containerClassName="search-input-wrapper !mt-0"
            wrapperClassName="!h-[4rem]"
            inputClassName="font-size-small"
            rightIcon={icons.searchIcon}
            onChange={(e) => setSearchText(e)}
            value={searchText}
          /> */}
        </div>
        <div className="flex items-center gap-x-3">
          <div className="font-size-medium">Date Range</div>
          <DatePicker
            startDate={startDate}
            endDate={endDate}
            onChange={onChangeDate}
            maxDate={new Date()}
            dateRange
          />
        </div>
      </div>
      <CustomTable
        data={data}
        columns={approvedRequestsColumns}
        showCheckboxes={true}
        onCheckboxSelect={(value) => {
          setCheckData(value);
        }}
        isGloablSearchEnable={true}
      />
      <div
        className={`mt-4 flex items-center justify-end gap-x-5 ${
          checkboxPropData.length > 0 ? "" : "disabled-kv"
        }`}
      >
        <CustomButton
          onClick={downloadRequestReports}
          title="Download"
          wrapperClassName="border-[1px] !border-[var(--blackColor)] !bg-transparent self-end !text-[var(--blackColor)] !px-8"
        />
      </div>
    </div>
  );
};

export default ApprovedRequests;
